<template>
  <div>
    <h1>Prize</h1>

    <p>I'll simply give you a foo.bar invitation link.
      I hope you share them if you get more referral links!</p>

    <hr/>

    <h1>How to Participate?</h1>

    <p>Read the problem below and write Python 2.7 code that passes all test cases and runs the fastest!</p>

    <h2>Deadline</h2>

    <p>
      You have till <b>20th Jun 2022 1200H SGT (UTC+08)</b>
      to submit a solution to me on Twitter/osu! DM using GitHub Gist or even a Repo.
    </p>

    <p>I'll announce the results on Twitter on the 21st ~ 22nd</p>

    <h2>Difficulty?</h2>
    <p>
      I tried to replicate difficulty of foo.bar. You need to pass Levels 1-3 in foo.bar
      to invite someone else! I'm hoping to choose someone who can do that, so we can share infinitely :)
    </p>
    <p>
      Passing level 4 will give you another invite! However, it'll be more difficult.
    </p>

    <hr/>
    <h1>Rules</h1>

    <ol>
      <li>Must pass all test cases</li>
      <li>Only use inbuilt libraries</li>
      <li>Fastest performing code wins (not how fast you code or submit).</li>
      <ol>
        <li><a href="https://www.jdoodle.com/ia/s8M">Find the template and execute your code here.</a></li>
        <li>I will try to run your code 10 times, the fastest time will be used</li>
      </ol>
    </ol>

    <hr/>

    <h1>Context</h1>

    <p>You are sent as an undercover BAT to discover gang-affiliated activities within Town Forky.</p>
    <p>Ground-intel uncovered 2 infamous groups, Manip Gang & Vibruh Gang.</p>
    <p>Scanning each citizen returns a list of integers from 0 to 15, inclusive.</p>
    <p>Each scan returns an encoding of a VSRG pattern.</p>
    <p>
      Your task is to feedback to HQ <b>whether the entity is affiliated with the Manip or Vibruh Gang, or none.</b>
    </p>
    <ul>
      <li>Not all entities are in a gang</li>
      <li>One cannot be in both Manip & Vibruh Gang</li>
    </ul>

    <h2>Encoding</h2>

    <p>The patterns are encoded using binary and added.</p>

    <h3>Example</h3>

    <pre>
Column 1 | O   .   .   O   .   O   .   .   O
Column 2 | O   .   O   .   .   O   .   .   O
Column 3 | .   O   .   O   .   .   O   .   O
Column 4 | .   O   .   .   O   .   .   O   O
         +------------------------------------+
         | 3,  12, 2,  5,  8,  3,  4,  8,  15 |
         +------------------------------------+
    </pre>
    <h3>Working</h3>

    <pre>
Col 1 + Col 2 = 2^0 + 2^1 = 3
Col 3 + Col 4 = 2^2 + 2^3 = 12
Col 2         = 2^1       = 2
Col 1 + Col 3 = 2^0 + 2^2 = 5
...
    </pre>

    <h2>Global Rules</h2>

    <ol>
      <li>No LNs</li>
      <li>4 Key</li>
      <li>Patterns can be interpreted as Downscroll or Upscroll, it doesn't matter</li>
      <li>The first & last index will always have a note.</li>
    </ol>

    <h1>Vibruh-Gang (Level 1)</h1>

    <p>You found that vibruh-patterns means: notes in the same column in a quick succession.</p>

    <h2>Rules</h2>

    <p>A pattern is vibruh if</p>

    <ol>
      <li>All jack notes are 1 index apart</li>
      <li>There are >= 4 notes in the same column one after another.</li>
      <li>As long as 1 column satisfies (1 & 2), they are in vibruh-gang</li>
    </ol>

    <h2>Examples</h2>

    <hr/>

    <code>Encoding: [3,3,1,1]</code>

    <pre>
           v-(A)-v
Column 1 | O O O O |
Column 2 | O O . . |
Column 3 | . . . . |
Column 4 | . . . . |
    </pre>

    <p>This pattern is vibruh.</p>

    <ol>
      <li>All jack are 1 index apart</li>
      <li>4 >= 4 notes in that jack sequence</li>
    </ol>

    <hr/>

    <code>Encoding: [11,6,15,13,11]</code>

    <pre>
Column 1 | O . O O O |
Column 2 | O O O . O |
Column 3 | . O O O . |
Column 4 | O . O O O |
    </pre>

    <p>This pattern is NOT vibruh. There exists no 4 jack notes in succession</p>

    <hr/>

    <code>Encoding: [9,14,9,14,9]</code>

    <pre>
Column 1 | O . O . O |
Column 2 | . O . O . |
Column 3 | . O . O . |
Column 4 | O O O O O |
           ^--(A)--^
    </pre>

    <p>This pattern is vibruh</p>

    <ol>
      <li>All jack are 1 index apart</li>
      <li>5 >= 4 notes in that jack sequence</li>
    </ol>

    <hr/>

    <h1>Manip-Gang (Level 2)</h1>

    <p>You discover that manip-patterns means: patterns possible to "approximate".</p>
    <p>We assume only quad-manipability, that means manip by pressing all keys.</p>


    <h2>Rules</h2>

    <p>A pattern is manipable as long as</p>

    <ol>
      <li>All 4 columns have same amount of notes</li>
      <li>The gap between each successive note in each column must be &le; 2</li>
      <ul>
        <li>Including the START and END of the pattern.</li>
      </ul>
      <li>They don't satisfy rules in vibruh-gang</li>
    </ol>

    <h2>Examples</h2>

    <hr/>

    <code>Encoding: [3,12,2,5,8,3,4,8,15]</code>

    <pre>
Column 1 | O . . O . O . . O |
Column 2 | O . O . . O . . O |
Column 3 | . O . O . . O . O |
Column 4 | . O . . O . . O O |
    </pre>

    <p>This pattern is Manipable.</p>

    <ol>
      <li>there are 4 notes in each column</li>
      <li>the gap between each note &le; 2</li>
      <li>Does not qualify as a vibruh pattern.</li>
    </ol>

    <hr/>

    <code>Encoding: [3,0,2,13,0,4,8]</code>

    <pre>
                   v(B)v
Column 1 | O . . O . . . |
Column 2 | O . O . . . . |
Column 3 | . . . O . O . |
Column 4 | . . . O . . O |
           ^(A)^
    </pre>

    <p>This pattern is NOT Manipable.</p>

    <ol>
      <li>there's a >= 2 gap between the start and end of pattern</li>
      <li>See <code>(A)</code>. Between the start of the pattern and column 3 & 4, there's a 3 wide gap, which violates
        rule 2.1.
      </li>
      <li>See <code>(B)</code>. Between column 1 and the end of the pattern, there's a 3 wide gap, which violates rule
        2.1
      </li>
    </ol>

    <hr/>

    <code>Encoding: [15,3,12,15,0,15]</code>

    <pre>
Column 1 | O O . O . O |
Column 2 | O O . O . O |
Column 3 | O . O O . O |
Column 4 | O . O O . O |
    </pre>

    <p>This pattern is Manipable.</p>

    <ol>
      <li>there are 4 notes in each column</li>
      <li>the gap between each note &le; 2</li>
      <li>no >= 4 notes in succession</li>
    </ol>

    <hr/>

    <h1>Foo.Bar requirements</h1>

    <ol>
      <li>Must be Python 2.7 (sorry no Java)</li>
      <li>Must be programmatic (no loading solutions from files)</li>
      <li>Must be as fast as possible (no brute force)</li>
    </ol>

    <hr/>

    <h1>Test Cases</h1>

    <p>There are no hidden test cases, however, make sure all of these pass.</p>

    <p>Use the following template script & compiler to time yourself.</p>

    <a href="https://www.jdoodle.com/ia/s8M">Find the template and execute your code here.</a>

    <p>I get around 2s so try to aim around that</p>

    <pre>
# Feel free to add more functions

def solution(pattern):
    # Insert your solution here!
    return

import timeit

test_cases = [
    [[3, 12, 3, 12, 3, 12], 'Manip Gang'],  # Jumptrill
    [[2, 1, 1, 1, 1], 'Vibruh Gang'],  # Col 1 Vibro
    [[1, 2, 4, 8, 1, 2, 4, 8], ''],  # Roll

    # Examples
    [[1, 1, 1, 1], 'Vibruh Gang'],
    [[3, 3, 1, 1], 'Vibruh Gang'],
    [[3, 12, 2, 5, 8, 3, 4, 8, 15], 'Manip Gang'],
    [[15, 3, 12, 15, 0, 15], 'Manip Gang'],
    [[9, 14, 9, 14, 9], 'Vibruh Gang'],
    [[3, 0, 3, 3, 12, 12, 0, 12], ''],
    [[15, 3, 15, 0, 0, 12], ''],
    [[3, 0, 2, 13, 0, 4, 8], ''],
    [[11, 6, 15, 13, 11], ''],
]

def benchmark():
    for test_case in test_cases:
        assert solution(test_case[0]) == test_case[1]
        assert solution(list(reversed(test_case[0]))) == test_case[1]


t = timeit.timeit('benchmark()', "from __main__ import benchmark", number=10000)
print("Time Taken (s): ", t)
    </pre>

  </div>
</template>


<script>
export default {
  name: "Blog005",
};

</script>

<style scoped></style>
